import React from 'react';
import { motion } from 'framer-motion';
import { FiMonitor, FiSettings, FiTarget, FiShare2, FiImage } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const services = [
  {
    icon: FiMonitor,
    title: 'Website Development',
    description: 'Professional websites designed to convert visitors into customers.'
  },
  {
    icon: FiSettings,
    title: 'Automation',
    description: 'Forms, CRM, WhatsApp, email sequences, and workflows that save time and improve efficiency.'
  },
  {
    icon: FiTarget,
    title: 'Lead Generation',
    description: 'Targeted ad campaigns and digital systems that help businesses attract qualified customers and generate consistent growth.'
  },
  {
    icon: FiShare2,
    title: 'Social Media Management',
    description: 'Strategic content planning, publishing, and account management to keep your business active and engaging across social platforms.'
  },
  {
    icon: FiImage,
    title: 'Content Creation',
    description: 'Professional graphics, branded visuals, and marketing content that help your business stand out and communicate effectively.'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">OUR SERVICES</h2>
          <p className="text-4xl md:text-5xl font-extrabold text-slate-900">Focused on Your Growth</p>
        </div>

        {/* 
          Using flex-wrap with justify-center to handle the "3 on top, 2 centered" layout 
          while maintaining perfect responsiveness.
        */}
        <div className="flex flex-wrap justify-center gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group p-10 bg-slate-50 rounded-[2.5rem] border border-slate-100 hover:bg-emerald-600 transition-all duration-500 hover:-translate-y-2 w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)] flex flex-col items-start"
            >
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-emerald-600 mb-8 shadow-sm group-hover:bg-white/20 group-hover:text-white transition-colors">
                <SafeIcon icon={service.icon} className="text-3xl" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-white transition-colors">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed group-hover:text-emerald-50 transition-colors">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
